<template>
  <v-dialog persistent v-model="active" width="480">
    <template v-slot:activator="{ on, attrs }">
      <v-btn rounded small class="mx-2" color="secondary" v-on="on" v-bind="attrs"
        >Registrar entrada de inventario</v-btn
      >
    </template>
    <v-card color="primary" class="ui-module-card rounded-sm">
      <v-card-title class="ui-module-titlebar">
        <div class="text-h6">Movimiento de entrada de accesorio</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="entradaItemForm" ref="form">
          <v-text-field
            class="ui-form-field"
            v-model="movimientoItem.fechaCompra"
            v-mask="'##/##/####'"
            hint="Formato de fecha: DD/MM/YYYY"
            rounded
            filled
            dense
            color="secondary"
            background-color="transparent"
            :rules="dateRules"
          >
            <template v-slot:label>Fecha de compra <span class="red--text">*</span> </template>
          </v-text-field>
          <v-text-field
            class="ui-form-field"
            v-model="movimientoItem.puestaDisposición"
            v-mask="'##/##/####'"
            hint="Formato de fecha: DD/MM/YYYY"
            rounded
            filled
            dense
            color="secondary"
            background-color="transparent"
            :rules="dateRules"
          >
            <template v-slot:label>Fecha de puesta a disposición <span class="red--text">*</span> </template>
          </v-text-field>
          <v-text-field
            class="ui-form-field"
            v-model.number="movimientoItem.cantidad"
            type="number"
            color="secondary"
            background-color="transparent"
            rounded
            filled
            dense
            min="0"
          >
            <template v-slot:label>Cantidad <span class="red--text">*</span> </template>
          </v-text-field>
          <v-textarea
            class="ui-form-field"
            label="Observaciones"
            v-model="movimientoItem.observaciones"
            rounded
            filled
            dense
            no-resize
            rows="3"
            color="secondary"
            background-color="transparent"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center ui-module-actions">
        <v-btn
          color="secondary"
          class="ui-module-btn-solid"
          :disabled="loading || !entradaItemForm"
          :loading="loading"
          @click="triggerSaveMovimientoItem()"
          >Registrar entrada</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  props: {
    idItem: {
      type: Number,
    },
  },

  data() {
    return {
      active: false,
      entradaItemForm: false,
      loading: false,

      movimientoItem: {
        fk_idCatItem: null,
        fk_idcatTipoMovimiento: 1,
        cantidad: 0,
        observaciones: '',
        fechaCompra: null,
        puestaDisposición: null,
      },

      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  methods: {
    ...mapActions('movimientoItem', ['saveMovimientoItem', 'fetchMovimientoItem']),

    closeDialog() {
      this.$refs.form.resetValidation()
      this.active = false
      this.movimientoItem = {
        fk_idCatItem: null,
        fk_idcatTipoMovimiento: 1,
        cantidad: 0,
        observaciones: '',
      }
      this.loading = false
    },

    async triggerSaveMovimientoItem() {
      this.loading = true
      this.movimientoItem.fk_idCatItem = this.idItem
      await this.saveMovimientoItem(this.movimientoItem)
      await this.fetchMovimientoItem()

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

::v-deep .ui-module-titlebar {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field textarea,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}
</style>
